export default function distributionstrategies(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                distributionstrategy: action.distributionstrategy,
            }
        default:
            return state;
    }
}
